import { render } from "./NoAccessState.vue?vue&type=template&id=dcb16f7e"
import script from "./NoAccessState.vue?vue&type=script&setup=true&lang=js"
export * from "./NoAccessState.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/NoAccessState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dcb16f7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dcb16f7e', __exports__)) {
    api.reload('dcb16f7e', __exports__)
  }
  
  module.hot.accept("./NoAccessState.vue?vue&type=template&id=dcb16f7e", () => {
    api.rerender('dcb16f7e', render)
  })

}


export default __exports__